import React from "react";
import userWhite from "@src/assets/svg/user-white.svg";
import styles from "./alarm-profile-email-recipients-list.module.scss";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { IconButton } from "@src/components/atoms/buttons/icon-button/icon-button";
import deleteIconLightGray from "@src/assets/svg/delete-icon-light-gray.svg";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import { getAlarmProfiles } from "@src/cloud-connect/dependency-injection-container/get-alarm-profiles";
import { useI18N } from "@src/language/language-context";
import { RenderIfUserHasPermission } from "../render-if-user-has-permission/render-if-user-has-permission";

interface AlarmProfileEmailRecipientsListProps {
  recipientsList: string[];
}

const cssClassName = "alarm-profile-email-recipients-list";

export const AlarmProfileEmailRecipientsList = ({
  recipientsList,
}: AlarmProfileEmailRecipientsListProps) => {
  const i18n = useI18N();

  const texts = {
    altText: i18n("modules.alarmProfileEmailRecipientsList.altText"),
  };

  const deleteRecipient = (recipientEmail) => {
    getAlarmProfiles()
      .getActiveAlarmProfile()
      .getNotifications()
      .getEmail()
      .removeRecipient(recipientEmail);
  };

  return (
    <FlexColumnContainer>
      {recipientsList &&
        recipientsList.map((recipient) => {
          return (
            <div
              key={recipient}
              className={styles[`${cssClassName}__recipient-box`]}
            >
              <FlexRowContainer>
                <img src={userWhite} alt={texts.altText} />
                <span className={styles[`${cssClassName}__recipient-box-text`]}>
                  {recipient}
                </span>
              </FlexRowContainer>

              <RenderIfUserHasPermission permission="manage-condition-monitoring">
                <IconButton
                  fun={() => deleteRecipient(recipient)}
                  icon={deleteIconLightGray}
                />
              </RenderIfUserHasPermission>
            </div>
          );
        })}
    </FlexColumnContainer>
  );
};
